module.exports = __webpack_public_path__ + "img/quote.ff45697c.png";